export default function () {
    return document.documentElement.hasAttribute('data-turbolinks-preview');
}
